import { Component, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-onlyoffice.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxOnlyOfficeComponent {
    /**
     * @return {?}
     */
    ngOnInit() {
        //
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.editor) {
            this.editor.destroyEditor();
        }
        this.createEditor();
    }
    /**
     * @private
     * @return {?}
     */
    createEditor() {
        if (typeof DocsAPI !== "undefined") {
            this.editor = new DocsAPI.DocEditor("onlyofficeEditor", this.config.editorConfig);
        }
        else {
            this.loadScript(this.config.script).then((/**
             * @param {?} i
             * @return {?}
             */
            (i) => {
                this.createEditor();
                // tslint:disable-next-line: no-console
            })).catch((/**
             * @param {?} e
             * @return {?}
             */
            (e) => console.error(e)));
        }
    }
    /**
     * @param {?} src
     * @return {?}
     */
    loadScript(src) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = src;
            if (script.readyState) {
                script.onreadystatechange = (/**
                 * @return {?}
                 */
                () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        resolve({ script: name, loaded: true, status: "Loaded" });
                    }
                });
            }
            else {
                script.onload = (/**
                 * @return {?}
                 */
                () => {
                    resolve({ script: name, loaded: true, status: "Loaded" });
                });
            }
            script.onerror = (/**
             * @param {?} error
             * @return {?}
             */
            (error) => resolve({ script: name, loaded: false, status: "Loaded" }));
            document.getElementsByTagName("head")[0].appendChild(script);
        }));
    }
}
NgxOnlyOfficeComponent.ɵfac = function NgxOnlyOfficeComponent_Factory(t) { return new (t || NgxOnlyOfficeComponent)(); };
NgxOnlyOfficeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxOnlyOfficeComponent, selectors: [["onlyoffice"]], inputs: { config: "config" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["id", "onlyofficeEditor"]], template: function NgxOnlyOfficeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, encapsulation: 2 });
NgxOnlyOfficeComponent.propDecorators = {
    config: [{ type: Input, args: ["config",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxOnlyOfficeComponent, [{
        type: Component,
        args: [{
                selector: "onlyoffice",
                template: `
    <div id="onlyofficeEditor"></div>
  `
            }]
    }], null, { config: [{
            type: Input,
            args: ["config"]
        }] }); })();
if (false) {
    /** @type {?} */
    NgxOnlyOfficeComponent.prototype.config;
    /** @type {?} */
    NgxOnlyOfficeComponent.prototype.editor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-onlyoffice.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxOnlyOfficeModule {
}
NgxOnlyOfficeModule.ɵfac = function NgxOnlyOfficeModule_Factory(t) { return new (t || NgxOnlyOfficeModule)(); };
NgxOnlyOfficeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxOnlyOfficeModule });
NgxOnlyOfficeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxOnlyOfficeModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxOnlyOfficeComponent],
                exports: [NgxOnlyOfficeComponent],
                imports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxOnlyOfficeModule, { declarations: [NgxOnlyOfficeComponent], exports: [NgxOnlyOfficeComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-onlyoffice.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxOnlyOfficeComponent, NgxOnlyOfficeModule };

